import "../../DarkMode.css";
import { Routes, Route } from "react-router-dom";
import Loadable from "react-loadable";
import Loader from "react-js-loader";

function Routing() {
  const loadableDelay = 300;

  const Login = Loadable({
    loader: () => import("../Login/Login"),
    loading: Loader,
    delay: loadableDelay,
  });

  const MasterDashboard = Loadable({
    loader: () => import("../MasterDashboard/MasterDashboard"),
    loading: Loader,
    delay: loadableDelay,
  });

  const AccountDashboardInNewTab = Loadable({
    loader: () => import("../AccountDashboard/AccountDashboardInNewTab/AccountDashboardInNewTab"),
    loading: Loader,
    delay: loadableDelay,
  });

  const AccountDashboard = Loadable({
    loader: () => import("../AccountDashboard/AccountDashboard"),
    loading: Loader,
    delay: loadableDelay,
  });

  const SubscriberDashboard = Loadable({
    loader: () => import("../SubscriberDashboard/SubscriberDashboard"),
    loading: Loader,
    delay: loadableDelay,
  });

  const DXPortal = Loadable({
    loader: () => import("../DXPortal/DXPortal"),
    loading: Loader,
    delay: loadableDelay,
  });

  const Accounts = Loadable({
    loader: () => import("../MasterDashboard/Accounts/Accounts"),
    loading: Loader,
    delay: loadableDelay,
  });

  const Subscribers = Loadable({
    loader: () => import("../MasterDashboard/Subscribers/Subscribers"),
    loading: Loader,
    delay: loadableDelay,
  });

  const Partners = Loadable({
    loader: () => import("../MasterDashboard/Partners/Partners"),
    loading: Loader,
    delay: loadableDelay,
  });

  const RatePlansTab = Loadable({
    loader: () => import("../MasterDashboard/RatePlansTab/RatePlansTab"),
    loading: Loader,
    delay: loadableDelay,
  });

  const UsagePricing = Loadable({
    loader: () => import("../MasterDashboard/UsagePricing/UsagePricing"),
    loading: Loader,
    delay: loadableDelay,
  });

  const Reports = Loadable({
    loader: () => import("../MasterDashboard/Reports/Reports"),
    loading: Loader,
    delay: loadableDelay,
  });

  const Resources = Loadable({
    loader: () => import("../MasterDashboard/Resources/Resources"),
    loading: Loader,
    delay: loadableDelay,
  });

  const Administration = Loadable({
    loader: () => import("../MasterDashboard/Administration/Administration"),
    loading: Loader,
    delay: loadableDelay,
  });

  const Roles = Loadable({
    loader: () => import("../MasterDashboard/Roles/Roles"),
    loading: Loader,
    delay: loadableDelay,
  });

  const Dev = Loadable({
    loader: () => import("../MasterDashboard/Dev/Dev"),
    loading: Loader,
    delay: loadableDelay,
  });

  const masterDashboardRoutes = [
    { path: "/masterDashboard/accounts", element: <Accounts /> },
    { path: "/masterDashboard/subscribers", element: <Subscribers /> },
    { path: "/masterDashboard/partners", element: <Partners /> },
    { path: "/masterDashboard/ratePlans", element: <RatePlansTab /> },
    { path: "/masterDashboard/usagePricing", element: <UsagePricing /> },
    { path: "/masterDashboard/reports", element: <Reports /> },
    { path: "/masterDashboard/resources", element: <Resources /> },
    { path: "/masterDashboard/administration", element: <Administration /> },
    { path: "/masterDashboard/roles", element: <Roles /> },
    { path: "/masterDashboard/dev", element: <Dev /> },
  ];

  return (
    <div className="Routing" style={{ height: "100%" }}>
      <Routes>
        <Route path="/" element={<Login />}></Route>
        <Route
          path="/masterDashboard"
          element={<MasterDashboard />}
          children={masterDashboardRoutes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        ></Route>
        <Route path="/accountDashboard" element={<AccountDashboardInNewTab />}></Route>
        <Route path="/dashboard/:accountId" element={<AccountDashboard isFromMasterDashboard={false} />}></Route>
        <Route path="/Subscriber/:id" element={<SubscriberDashboard />}></Route>
        <Route path="/DXPortal" element={<DXPortal />}></Route>
      </Routes>
    </div>
  );
}

export default Routing;
